import { useLoaderData, useNavigate, useSubmit } from 'react-router';
import ListActions from '@/components/core/ListActions';
import LoadMoreButton from '@/components/core/LoadMoreButton';
import { confirm } from '@/components/core/createConfirmation';
import { getProjectsPage } from '@/api/projects';
import usePagination from '@/hooks/usePagination';
import featureConfig from '@/featureConfig';

const ProjectList = () => {
  const { projects: initialProjects, nextPage: initialNextPage } = useLoaderData();
  const {
    items: projects,
    loading,
    hasMore,
    loadMore,
  } = usePagination(initialProjects, initialNextPage, getProjectsPage);

  const submit = useSubmit();
  const navigate = useNavigate();

  const remove = async project => {
    if (await confirm('Are you sure you want to remove this project?')) {
      submit(
        {},
        {
          method: 'delete',
          action: `/projects/${project.id}/destroy`,
        },
      );
    }
  };

  const onOpen = (projectId, event) => {
    if (event.target.tagName === 'TD') {
      navigate(`/projects/${projectId}/dashboard`);
    }
  };

  const edit = project => navigate(`/projects/${project.id}/edit`);

  if (!projects.length) {
    return <p className="p-5 text-center">No projects found</p>;
  }

  return (
    <>
      <table className="w-full text-gray-500">
        <tbody>
          {projects.map(project => (
            <tr
              key={project.id}
              onClick={event => onOpen(project.id, event)}
              className="group cursor-pointer flex justify-between items-center hover:bg-gray-100 hover:text-gray-800"
            >
              <td className="px-6 py-3 text-gray-700 text-sm flex-1">{project.name}</td>
              <td className="justify-end group-hover:flex hidden">
                {featureConfig.manageProjects && <ListActions item={project} onRemove={remove} onEdit={edit} />}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <LoadMoreButton onLoadMore={loadMore} loading={loading} hasMore={hasMore} />
    </>
  );
};

export default ProjectList;
